import { __rest } from "tslib";
import React from 'react';
import { InputGroup } from '../InputGroup';
import { ComponentSize } from '../types';
import { withLabels } from '../../hoc';
import { Container, Row, TextField, Button } from './styled';
import { CrossIcon } from '../../tempIcons/CrossIcon';
import { theme } from '../../theme';
export const DimensionsInput = withLabels((_a) => {
    var { size = ComponentSize.base, handleChangeHeight, handleChangeWidth, handleChangeLength, className, height, width, length, unit } = _a, rest = __rest(_a, ["size", "handleChangeHeight", "handleChangeWidth", "handleChangeLength", "className", "height", "width", "length", "unit"]);
    return (React.createElement(Container, { className: className },
        React.createElement(Row, null,
            React.createElement(TextField, Object.assign({ onChange: handleChangeLength, size: size, name: "length", type: "number", placeholder: "L", value: length }, rest)),
            React.createElement(CrossIcon, { height: theme.sizes.base, width: theme.sizes.base }),
            React.createElement(TextField, Object.assign({ onChange: handleChangeWidth, size: size, name: "width", type: "number", placeholder: "W", value: width }, rest)),
            React.createElement(CrossIcon, { height: theme.sizes.base, width: theme.sizes.base }),
            React.createElement(InputGroup, null,
                React.createElement(TextField, Object.assign({ onChange: handleChangeHeight, size: size, name: "height", type: "number", placeholder: "H", value: height }, rest)),
                React.createElement(Button, { size: size }, unit)))));
});
DimensionsInput.displayName = 'DimensionsInput';
//# sourceMappingURL=DimensionsInput.js.map